import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-mobile-buttons-bar',
  templateUrl: './mobile-buttons-bar.component.html',
  styleUrls: ['./mobile-buttons-bar.component.scss'],
  standalone: false
})
export class MobileButtonsBarComponent implements OnInit {
  @Output() buttonClicked = new EventEmitter();
  @Input() files!: any[];
  @Input() isLoading!: boolean;
  constructor() { }

  ngOnInit() { }

}
